export const LocalStorageKeys = {
  trestleToken: "trestleToken",
  currentListing: "currentListing",
};
